<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1">
<h1 style="margin-top:250px;font-family:Arial;">Part 1</h1>
<p style="text-align: center"><img alt="" src="media/file0.png" style="width:4.78502in;height:4.1219in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?48f6dd97